export default __webpack_public_path__ + "static/media/image_assets.1f527ed8.png";